var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.away,
          expression: "away"
        }
      ],
      staticClass: "notification"
    },
    [
      _c(
        "div",
        {
          staticClass: "notification__header",
          class: { "notification__header--active": _vm.click },
          on: { click: _vm.toggleDropdown }
        },
        [_vm._t("fa-icon")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "notification__content",
          style: { "--max-height-notification-content": _vm.maxContentHeight }
        },
        [_vm._t("content")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b140d06", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b140d06","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/DropdownNotification.vue
// module id = 253
// module chunks = 0